import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

// Definir headers globais
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.response.use(
  (response) => (response.data ? response.data : response),
  (error) => {
    let message;
    const status = error.response?.status;
    switch (status) {
      case 500:
        message = "Erro interno do servidor.";
        break;
      case 400:
        message = error;
        break;
      case 401:
        message = "Credenciais inválidas.";
        break;
      case 404:
        message = error;
        break;
      default:
        message = error.message || "Erro desconhecido.";
    }

    return Promise.reject(message);
  }
);

class APIClient {
  get = async (url: string, params?: any): Promise<AxiosResponse> => {
    try {
      let paramKeys: string[] = [];
      if (params) {
        Object.keys(params).map((key) => {
          paramKeys.push(key + "=" + params[key]);
          return paramKeys;
        });

        const queryString = paramKeys.length ? paramKeys.join("&") : "";
        return axios.get(`${url}?${queryString}`);
      } else {
        return axios.get(url);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };

  create = (url: string, data: any) => {
    return axios.post(url, data);
  };

  patch = (url: string, data: any) => {
    return axios.patch(url, data);
  };

  put = (url: string, data: any) => {
    return axios.put(url, data);
  };

  delete = (
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.delete(url, { ...config });
  };
}

export { APIClient };

